import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 点我查看更多内容 ")

import { NTabs, NTabPane } from "naive-ui";

import setList from "@/components/set-list";

// type set = {
//   title: string,
//   name: string,
//   id: string
// }


export default /*#__PURE__*/_defineComponent({
  props: ['setsData', 'maxLength', 'showMore', 'tabIndex'],
  setup(__props) {

const props = __props





return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(NTabs), {
    "justify-content": "space-evenly",
    type: "line"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.setsData, (set, index) => {
        return (_openBlock(), _createBlock(_unref(NTabPane), {
          name: `${set.name}`,
          tab: set.title,
          key: index
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(setList), {
              id: set.id,
              keyword: set.keyword,
              maxLength: props.maxLength
            }, null, 8, ["id", "keyword", "maxLength"]),
            (__props.showMore)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "show-more",
                  to: { name: 'Catalog', query: { index: `${set.name}` } }
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["name", "tab"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})